import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Ajv from 'ajv';
import localize from 'ajv-i18n';
import i18next from 'i18next';
import TH from '@/locale/th';
import { optionsError } from '@/app/configs/OptionToast';
import Schema from '@/app/schema/Schema';

Vue.use(Vuetify);

const ajv: any = new Ajv({ allErrors: true, jsonPointers: true });

export default function compileSchema(valueInput: any, jsonSchema: any){
  if (valueInput && jsonSchema){
    const AJVSchemaValidate = ajv.validate(jsonSchema, valueInput);
    localize.th(ajv.errors);

    const dataPath = ajv.errors && ajv.errors.length > 0 ? ajv.errors[0].dataPath.substring(1) : null;
    i18next.init({
      lng: 'th',
      resources: TH
    }, (err, t) => {
      if (err){
        console.log('error : ', err);
      }
    });
    let returnValue: any;
    if (ajv.errors && ajv.errors.length > 0){
      if (ajv.errors[0].keyword === 'type' && ajv.errors[0].dataPath === '/productImage' && ajv.errors[0].params.type === 'string'){
        returnValue = 'กรุณาเลือกรูปภาพ';
      } else if (ajv.errors[0].keyword === 'type'){
        returnValue = `กรุณากรอก ${i18next.t(dataPath)}`;
      } else if (ajv.errors[0].keyword === 'minimum' && ajv.errors[0].params.comparison === '<='){
        returnValue = `${i18next.t(dataPath)} ควรน้อยกว่าหรือเท่ากับ ${ajv.errors[0].params.limit}`;
      } else if (ajv.errors[0].keyword === 'minimum' && ajv.errors[0].params.comparison === '>='){
        returnValue = `${i18next.t(dataPath)} ควรมากกว่าหรือเท่ากับ ${ajv.errors[0].params.limit}`;
      } else if (ajv.errors[0].keyword === 'maximum' && ajv.errors[0].params.comparison === '<='){
        returnValue = `${i18next.t(dataPath)} ควรน้อยกว่าหรือเท่ากับ ${ajv.errors[0].params.limit}`;
      } else if (ajv.errors[0].keyword === 'maximum' && ajv.errors[0].params.comparison === '>='){
        returnValue = `${i18next.t(dataPath)} ควรมากกว่าหรือเท่ากับ ${ajv.errors[0].params.limit}`;
      } else if (ajv.errors[0].keyword === 'pattern' && ajv.errors[0].params.pattern === '^[0].*'){
        returnValue = `${i18next.t(dataPath)} ต้องขึ้นต้นด้วย 0`;
      } else if (ajv.errors[0].keyword === 'pattern' && ajv.errors[0].params.pattern === '[a-zA-Z0-9_\\.\\+-]+@[a-zA-Z0-9-]+\\.[a-zA-Z0-9-\\.]+'){
        returnValue = `${i18next.t(dataPath)} ไม่ถูกต้อง เช่น example@example.com`;
      } else if (ajv.errors[0].keyword === 'required' && ajv.errors[0].message === 'ควรมี property buyQty ที่บังคับไว้'){
        returnValue = 'กรุณากรอกจำนวนของสินค้า';
      } else {
        returnValue = i18next.t(dataPath).concat('&nbsp;') + (i18next.t(ajv.errors[0].message));
      }
    }

    return {
      pass: AJVSchemaValidate,
      message: ajv.errors && ajv.errors.length > 0
        ? Vue.toasted.show(returnValue, optionsError)
        : '',
      errors: ajv.errors
    };
  }
  return Vue.toasted.show('Error Schema', optionsError);
}
